/* assets/variants.js */
(function () {
  function S(v) {
    return v == null ? '' : String(v);
  }

  // Cut label before dash / en-dash / em-dash
  function cutBeforeDash(str) {
    const s = S(str).trim();
    if (!s) return '';
    const parts = s.split(/\s*[–—-]\s*/); // –, —, -
    return (parts[0] || s).trim();
  }

  // Legacy logic: take part after ' - '
  function stripProductTitleLabel(str) {
    let label = S(str).trim();
    const idx = label.lastIndexOf(' - ');
    if (idx !== -1) label = label.slice(idx + 3);
    return label.trim();
  }

  function buildShortLabel(p) {
    const full = S(p && p.shortname_full).trim();
    if (full) return cutBeforeDash(full);

    const base = p && (p.title || p.handle || p.url) ? (p.title || p.handle || p.url) : '';
    return stripProductTitleLabel(base);
  }

  function buildFullLabel(p) {
    const full = S(p && p.shortname_full).trim();
    if (full) return full;

    const base = p && (p.title || p.handle || p.url) ? (p.title || p.handle || p.url) : '';
    return stripProductTitleLabel(base);
  }

  function createPillContent(text, iconUrl) {
    if (!iconUrl) return document.createTextNode(text);

    const frag = document.createDocumentFragment();

    const img = document.createElement('img');
    img.className = 'incl__pillIcon';
    img.alt = '';
    img.loading = 'lazy';
    img.src = iconUrl;

    frag.appendChild(img);
    frag.appendChild(document.createTextNode(text));
    return frag;
  }

  function init() {
    if (!Array.isArray(window.variations_new)) return;

    const container = document.getElementById('var-inside');
    if (!container) return;

    container.innerHTML = '';

    // Title as default h3
    const titleEl = document.createElement('h3');
    titleEl.className = 'variation__title';
    titleEl.innerHTML =
      '<span class="variation__titleKey">Darreichungsform:</span> <span data-current-full></span>';
    container.appendChild(titleEl);

    const currentFullEl = titleEl.querySelector('[data-current-full]');

    // ✅ Wrapper for pills
    const pillsWrap = document.createElement('div');
    pillsWrap.className = 'variant__picker';
    container.appendChild(pillsWrap);

    let hasLinks = false;

    // Links (other variations)
    window.variations_new.forEach((p) => {
      if (!p || !p.url) return;

      const shortLabel = buildShortLabel(p);
      const fullLabel = buildFullLabel(p);

      const a = document.createElement('a');
      a.href = p.url;
      a.setAttribute('data-full', fullLabel);
      a.appendChild(createPillContent(shortLabel, S(p.icon_url)));

      pillsWrap.appendChild(a);
      hasLinks = true;
    });

    if (!hasLinks) return;

    // Current label (from metafield preferred)
    const currentFull = S(window.current_shortname).trim();
    const currentFullFallback = stripProductTitleLabel(
      document.querySelector('.h1.product-single__title')?.textContent ||
        document.querySelector('.h2.product-single__title')?.textContent ||
        ''
    );

    const currentFullLabel = currentFull || currentFullFallback;
    const currentShortLabel = cutBeforeDash(currentFullLabel) || currentFullLabel;

    if (currentFullEl) currentFullEl.textContent = currentFullLabel;

    // Insert current "pill" as span at the beginning of pills wrapper
    const existing = pillsWrap.querySelector('span[data-current-variant="true"]');
    if (!existing) {
      const span = document.createElement('span');
      span.setAttribute('data-current-variant', 'true');
      span.appendChild(createPillContent(currentShortLabel, S(window.current_icon_url)));

      pillsWrap.insertBefore(span, pillsWrap.firstChild);
    }

    // Hide current handle link if it exists inside list
    const currentHandle = S(window.current_handle).trim();
    if (currentHandle) {
      pillsWrap.querySelectorAll('a').forEach((a) => {
        const href = a.getAttribute('href') || '';
        if (href.includes('/products/' + currentHandle)) {
          a.style.display = 'none';
        }
      });
    }

    // Hide default variant picker (safety)
    const variantWrapper = document.querySelector('.variant-wrapper.small--text-center.js');
    if (variantWrapper) variantWrapper.style.display = 'none';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme editor re-render
  document.addEventListener('shopify:section:load', init);
})();
